import { render, staticRenderFns } from "./ActivateValidatorPaymentModal.vue?vue&type=template&id=b3b5c89a&scoped=true"
import script from "./ActivateValidatorPaymentModal.vue?vue&type=script&lang=js"
export * from "./ActivateValidatorPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./ActivateValidatorPaymentModal.vue?vue&type=style&index=0&id=b3b5c89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b5c89a",
  null
  
)

export default component.exports